/**
 * use-system-config — 系统配置域读写 API（ADM-SYS-S001 地区 / S002 语言 / S003 运营弹窗 access level）
 *
 * 语言 / 区域为系统级元数据，admin 仅可 PATCH `enabled` 启停（主键 / display_name /
 * app_selectable / default_timezone 由发版 seed 维护）。响应返更新后整行 DTO，
 * 调用方据此 toast 服务端真值并 invalidate ['sys-config'] 刷新列表。
 */

import type {
  PopupAccessLevelResponse,
  PopupAccessLevelScenario,
  SystemLanguageResponse,
  SystemRegionResponse,
} from '@novel-admin/shared';
import { apiRequest } from '~/api/client';

export const systemConfigApi = {
  /** PATCH /api/v1/system-config/languages/:code — 仅 enabled 可改（en 行后端 DB CHECK 锁定） */
  updateLanguageEnabled: (code: string, enabled: boolean) =>
    apiRequest<SystemLanguageResponse>({
      method: 'PATCH',
      path: `/api/v1/system-config/languages/${code}`,
      body: { enabled },
    }),
  /** PATCH /api/v1/system-config/regions/:code — 仅 enabled 可改 */
  updateRegionEnabled: (code: string, enabled: boolean) =>
    apiRequest<SystemRegionResponse>({
      method: 'PATCH',
      path: `/api/v1/system-config/regions/${code}`,
      body: { enabled },
    }),

  // ADM-SYS-S003 运营弹窗 access level（A5 §11）——**全系统一份、所有 App 共用**，
  // 不带 app_id、不接受 App 覆盖；App 维度只决定该场景是否上架（A2 §5）。
  /** GET /api/v1/system-config/popup-access-levels — 场景闭集全集（未配置的返 null） */
  listPopupAccessLevels: () =>
    apiRequest<PopupAccessLevelResponse[]>({
      method: 'GET',
      path: '/api/v1/system-config/popup-access-levels',
    }),
  /** PUT /:scenario — 写 / 清空（null=清空）；写档 root/admin + MFA，比语言·地区更窄 */
  setPopupAccessLevel: (scenario: PopupAccessLevelScenario, accessLevelId: string | null) =>
    apiRequest<PopupAccessLevelResponse>({
      method: 'PUT',
      path: `/api/v1/system-config/popup-access-levels/${scenario}`,
      body: { access_level_id: accessLevelId },
    }),
};
